import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/Modal'
import ConditionalRender from 'components/shared/ConditionalRender'
import CircleOfWaiting from 'components/shared/CircleOfWaiting'
import { authorizeApp } from 'app/modules/integrations/api'
import withNotifications from 'components/shared/notifications'
import { defaultTo, isEmpty } from 'ramda'

import { renderRedirectViewInWindow } from './redirectWindow'

import driftLogoSrc from 'images/logos/drift.svg'
import defaultAppIconSrc from 'images/svg/default-app-icon.svg'

import './style.styl'

const orDefaultIconSrc = (src) => defaultTo(defaultAppIconSrc)(src)

class ExternalIntegrationInstallModal extends Component {

  static propTypes = {
    onAuthorized: PropTypes.func.isRequired,
    scopes: PropTypes.array.isRequired,
    appIconSrc: PropTypes.string.isRequired,
    appId: PropTypes.string.isRequired,
    appName: PropTypes.string.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired
  }

  state = {
    isAuthorizing: false
  }

  openRedirectWindow = () => {
    const redirectWindow = window.open('', '_blank')
    renderRedirectViewInWindow(redirectWindow)
    return redirectWindow
  }

  authorizeApp = () => {
    const { appId } = this.props
    const { isAuthorizing, notifications, onAuthorized } = this.props

    if (isAuthorizing) return

    const redirectWindow = this.openRedirectWindow()
    const onDone = ({ redirectUrl }) => {
      redirectWindow.location = redirectUrl
      this.setState({ isAuthorizing: false }, onAuthorized)
    }

    const onError = () => {
      notifications.error('Ooops, something went wrong. Plese try again.')
      this.setState({ isAuthorizing: false })
    }

    const onStateSet = () => authorizeApp(appId)
      .then(onDone)
      .catch(onError)

    this.setState({ isAuthorizing: true }, onStateSet)
  }

  render() {
    const { isOpen, closeModal, appName, appIconSrc, scopes } = this.props
    const { isAuthorizing } = this.state

    return (
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        className="external-integration-install-modal">

        <div className="external-integration-install-modal-content">
          <div className="external-integration-install-modal-logos">
            <img src={orDefaultIconSrc(appIconSrc)} alt="drift logo" />
            <img src={driftLogoSrc} alt="app logo" />
          </div>

          <h1 className="external-integration-install-modal-title">
            Install {appName} to Drift
          </h1>

          <ConditionalRender condition={!isEmpty(scopes)}>
            <span className="external-integration-install-modal-description">
              {appName} would like these permissions in Drift
            </span>
            <ul className="external-integration-install-modal-scopes">
              {scopes.map((scope, index) => (
                <li key={index}>
                  {scope.description}
                </li>
              ))}
            </ul>
          </ConditionalRender>

          <div className="external-integration-install-modal-buttons">
            <button
              className="drift-button drift-button-ternary"
              onClick={closeModal}>
              Cancel
            </button>
            <button
              className="drift-button drift-button-primary external-integration-authorize-button"
              onClick={this.authorizeApp}>
              <ConditionalRender condition={!isAuthorizing}>
                Authorize App
              </ConditionalRender>
              <ConditionalRender condition={isAuthorizing}>
                <CircleOfWaiting />
              </ConditionalRender>
            </button>
          </div>
        </div>

      </Modal>
    )
  }
}

export default withNotifications(ExternalIntegrationInstallModal)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/ExternalIntegrationInstallModal/index.js